module.exports = __webpack_public_path__ + "static/img/VA.620756c8.png";